<!-- 
   INPUT PARA SELECAO DE CORES
-->

<script>
import { SysVars } from '../main';
import { apiORDS } from '../shared/api-functions'

export default {
    props: {
        params: {},
        value: {},
        disabled: Boolean,
    },

    data () {
        return {

            textSearch: '',
            inicio: true,
            noList: true,
            showList: false,
            originalTop: 0,

            isChoosing: true,

            selectedIndex: null,
            selected: null,

            list: [
                { id: 1, text: 'teste1', color: 'red' },
                { id: 2, text: 'teste2', color: 'green' },
                { id: 5, text: 'teste3', color: 'green' },
                { id: 6, text: 'teste4', color: 'green' },
                { id: 7, text: 'teste5', color: 'blue' }
            ],

        }
    },

    computed: {

        metadata: function () {
            return this.$store.getters.getEntities.metadata
        },

        administrador: function () {
            return SysVars.usuarioAdministrador
        },

    },

    filters: {
        
    },

    methods: {
        handleEsc() {            
            this.showList = false
        },

        handleKeyDown () {
            //TECLA PARA BAIXO
            if (this.disabled)
              return
            if (!this.showList)
              this.show()

            if (this.list.length > 0) {
                if (this.selectedIndex > this.list.length) {
                    this.selectedIndex = 0
                } else {
                    this.selectedIndex = this.selectedIndex + 1
                }
            }
        },

        handleKeyUp () {            
            //TECLA PARA CIMA
            if (this.disabled)
              return
            if (!this.showList)
              this.show()
            if (this.list.length > 0) {
                if (this.selectedIndex < 1) {
                    this.selectedIndex = this.list.length - 1
                } else {
                    this.selectedIndex = this.selectedIndex - 1
                }
            }
        },

        handleAdicionar () {
            this.$emit('adicionar')
        },

        handleEditar (index) {
            this.$emit('editar', this.list[index].value)
        },

        focus () {            
            this.$refs.pesquisa.focus()
        },

        handleBlur () {            
            // this.showList = false
        },

        handleChange(evt) {
            this.$refs.pesquisa.value = '' 
        },

        handleSelectItem(index) {                     
            //AO SELECIONAR UM REGISTRO
            if (index === null) {
                this.selectedIndex = null
                this.selected = null
                this.$emit('input', null)
                this.$emit('select', null)
                return
            }
            this.selectedIndex = index
            
            if (this.list.length > 0) {
                this.selected = this.list[this.selectedIndex]
                this.showList = false
                this.isChoosing = false
                this.textSearch = ''
                this.$emit('input', this.selected.value)
                this.$emit('select', this.selected)
            }
        },

        show () {
            if (this.disabled)
              return
            this.showList = !this.showList
        },

        isSelected (index) {
            return index == this.selectedIndex
        },

        handleStyle(color) {
            if (color)
              return 'color: white; background-color: ' + color;
            else 
              return ''
        },

        focusControl: function (event) {        
            var thisIndex = jQuery(this.$el.querySelector('input')).index(SysVars.sFocusControl)
            var next = thisIndex + 1
            var obj = jQuery(SysVars.sFocusControl)
            for (var x = next; x < obj.length; x++) {
                if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled")) {
                    jQuery(obj[x]).focus()
                    break
                }
            }
        },

        async loadData () {            

            this.list = []

            const data = await apiORDS(this.$store.getters.urlOrds + this.params.url)
            if (data.items) {
                this.list = data.items
            }

            if (this.value && !this.selected)
              this.setValue()
        },

        setValue () {
            this.selectedIndex = null
            this.selected = null
            for (var i=0; i < this.list.length; i++) {
                if (this.list[i].value == this.value) {
                    this.selectedIndex = i
                    this.selected = this.list[i]
                    break
                }
            } 
        },

    },

    watch: {

        list: function () {
            if (this.inicio) {
                return
            }
            if (!this.list.length) {
                this.noList = true
                this.showList = false
            } else {
                this.noList = false
                this.showList = true
            }
        },

        value: function () {
            if (!this.selected || this.value != this.selected.value) {
                this.setValue()
            }
        },

    },

    components: {

    },

    created () {
        if (this.params.url)
           this.loadData()
        else
           this.list = this.params.list //lista fixa
    },

    mounted () {
        if (this.value) {
            this.setValue()
        }
    }

}

</script>

<template>
    <div class="w-100">
            <div class="form-group form-group-sm">
                <div v-if="(params.label || metadata)">
                    <v-label :label="params.label"></v-label>
                </div>
                <div class="btn-group dropright">
                    <button ref="pesquisa" class="btn btn-outline-secondary btn-sm dropdown-toggle" data-toggle="dropdown" style="min-width: 100px; border-radius: 0%" > 
                        <span v-if="!selected">Nenhum</span>
                        <span v-if="selected" class="input-tag tag-input-color" :style="handleStyle(selected.cor)">{{ selected.title }}</span>
                    </button>
                    <div class="dropdown-menu">
                        <div class="w-100">
                            <a class="dropdown-item mb-2" href="#" v-for="(item, index) in list" :key="index" @click="handleSelectItem(index)"> 
                                <i v-if="params.edit && administrador" class="fa fa-pencil mt-1 pr-3" title="Editar" @click="handleEditar(index)"></i>
                                <span class="tag-input-color" :style="handleStyle(item.cor)"> {{ item.title }} </span> 
                            </a>
                            
                        </div>
                        <div class="divider"></div>
                        <a class="dropdown-item" href="#" @click="handleSelectItem(null)">Sem Etiqueta</a>
                        <div v-if="params.edit && administrador">
                            <div class="divider"></div>
                            <a class="dropdown-item" href="#" @click="handleAdicionar">Incluir Etiqueta</a>
                        </div>
                    </div>
                </div>

                <!-- <input ref="pesquisa" class="teste-cursor form-control form-control-sm" type="text" 
                    v-model="textSearch" 
                    @blur="handleBlur()" 
                    @keyup.esc="handleEsc()"
                    @keyup.enter="handleSelectItem()"
                    @click="show"
                    @keyup.down="handleKeyDown()" 
                    @keyup.up="handleKeyUp()"
                    @input="handleChange">
                <span v-if="selected" class="input-tag tag-input-color" :style="handleStyle(selected.cor)">{{ selected.title }}</span> -->

            </div>

    </div>

</template>





<style>

.input-color {
    z-index: 1051;
    position: absolute;
    top: 80%;
    max-width: 100%;
    display: block;
    list-style: none;
    background-color: #fff;
    border: 1px solid #ccc;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,0.2);
    -moz-box-shadow: 0 5px 10px rgba(0,0,0,0.2);
    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
}

.input-color .active {
    color: white;
    background-color: #317ae2;
}

.input-color * {
    white-space: normal!important;
}

.input-color-data {
    white-space: normal!important;
}

.input-color-title {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    margin-right: 5px;
    font-size: 18px;
}

.input-color .faixa {
    height: 35px;
}

.input-color .faixa:hover {
    background-color: #317ae2;
    cursor: pointer;
}

.input-tag {
    margin-right: 15px;
    min-width: 50px;
    /* position: absolute;
    left: 20px;
    top: 10px;
    height: 25px;
    min-width: 50px; */
}

.input-color-footer {
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: end;
  width: 100%;
  border-top: 1px solid #c9d3dd;
}

.teste-cursor {
    color: white;
    background: white;
    text-shadow: 0 0 0 #2196f3;
}

.teste-cursor:focus {
    outline: none;
}

</style>





// WEBPACK FOOTER //
// src/components/input-color.vue